import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 修复 Vue Router 3 中 router.push/replace 没有 catch 时抛出的无害导航取消警告
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (
      err.name !== 'NavigationDuplicated' &&
      err.name !== 'NavigationCancelled' &&
      !err.message?.includes('redundant navigation') &&
      !err.message?.includes('Navigation cancelled')
    ) {
      throw err
    }
  })
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/Layout.vue'),
    meta: { requiresAuth: true },
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-home' }
      },
      {
        path: '/user',
        name: 'AdminUser',
        component: () => import('@/views/user/UserList.vue'),
        meta: { title: '管理员管理', icon: 'el-icon-user' }
      },
      {
        path: '/platform-user',
        name: 'PlatformUser',
        component: () => import('@/views/user/PlatformUserList.vue'),
        meta: { title: '普通用户管理', icon: 'el-icon-users' }
      },
      {
        path: '/company',
        name: 'Company',
        component: () => import('@/views/company/CompanyList.vue'),
        meta: { title: '企业管理', icon: 'el-icon-building' }
      },
      {
        path: '/role',
        name: 'Role',
        component: () => import('@/views/role/RoleList.vue'),
        meta: { title: '角色管理', icon: 'el-icon-suitcase' }
      },
      {
        path: '/menu',
        name: 'Menu',
        component: () => import('@/views/menu/MenuList.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import('@/views/order/OrderList.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: '/question-bank',
        name: 'QuestionBank',
        component: () => import('@/views/question-bank/QuestionBankList.vue'),
        meta: { title: '题目管理', icon: 'el-icon-edit-outline' }
      },
      {
        path: '/quiz-config',
        name: 'QuizConfig',
        component: () => import('@/views/question-bank/QuizConfigList.vue'),
        meta: { title: '答题配置', icon: 'el-icon-setting' }
      },
      {
        path: '/quiz-record',
        name: 'QuizRecord',
        component: () => import('@/views/question-bank/QuizRecordList.vue'),
        meta: { title: '答题记录', icon: 'el-icon-document' }
      },
      {
        path: '/question-type',
        name: 'QuestionType',
        component: () => import('@/views/question-type/QuestionTypeList.vue'),
        meta: { title: '题型管理', icon: 'el-icon-price-tag' }
      },
      {
        path: '/user-purchase',
        name: 'UserPurchase',
        component: () => import('@/views/user-purchase/UserPurchaseList.vue'),
        meta: { title: '购买记录', icon: 'el-icon-shopping-cart-full' }
      },
      {
        path: '/attachment-category',
        name: 'AttachmentCategory',
        component: () => import('@/views/attachment/CategoryList.vue'),
        meta: { title: '文件分类', icon: 'el-icon-folder' }
      },
      {
        path: '/attachment-file',
        name: 'AttachmentFile',
        component: () => import('@/views/attachment/FileList.vue'),
        meta: { title: '文件管理', icon: 'el-icon-files' }
      },
      {
        path: '/login-log',
        name: 'LoginLog',
        component: () => import('@/views/login-log/LoginLogList.vue'),
        meta: { title: '登录日志', icon: 'el-icon-document' }
      },
      {
        path: '/operation-log',
        name: 'OperationLog',
        component: () => import('@/views/operation-log/OperationLogList.vue'),
        meta: { title: '操作日志', icon: 'el-icon-document' }
      },
      {
        path: '/system-config',
        name: 'SystemConfig',
        component: () => import('@/views/system-config/SystemConfigList.vue'),
        meta: { title: '系统设置', icon: 'el-icon-setting' }
      },
      {
        path: '/carousel',
        name: 'Carousel',
        component: () => import('@/views/carousel/CarouselList.vue'),
        meta: { title: '轮播管理', icon: 'el-icon-picture' }
      },
      {
        path: '/banner',
        name: 'Banner',
        component: () => import('@/views/banner/BannerList.vue'),
        meta: { title: 'Banner管理', icon: 'el-icon-picture' }
      },
      {
        path: '/user-feedback',
        name: 'UserFeedback',
        component: () => import('@/views/user-feedback/UserFeedbackList.vue'),
        meta: { title: '用户反馈管理', icon: 'el-icon-chat-line-round' }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/profile/Profile.vue'),
        meta: { title: '个人中心', icon: 'el-icon-user' }
      },
      {
        path: '/discount/coupon',
        name: 'coupon',
        component: () => import('@/views/discount/coupon.vue'),
        meta: { title: '优惠卷管理', icon: 'el-icon-chat-line-round' }
      },
      {
        path: '/discount/couponToReceive',
        name: 'couponToReceive',
        component: () => import('@/views/discount/couponToReceive.vue'),
        meta: { title: '优惠卷领取', icon: 'el-icon-chat-line-round' }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token')
  // 检查整个路由链（包括父路由）中是否有 requiresAuth，而非只看当前子路由的 meta
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    // 未登录，跳转登录页，用 replace 避免在历史记录中淡留中间页
    next({ path: '/login', replace: true })
  } else if (to.path === '/login' && isAuthenticated) {
    // 已登录且访问登录页，直接跳首页
    next({ path: '/dashboard', replace: true })
  } else {
    next()
  }
})

export default router